import { onAuthStateChanged } from 'firebase/auth';
import { useContext, useEffect } from 'react';
import { labels } from '../../constants';
import { UiContext } from '../../contexts';
import { auth as FirebaseAuth } from '../../infrastructures/firebase';

/*
 * ログイン中にセッションが切れた場合（パスワード変更や別タブでのログアウトなど）、
 * 画面はログイン済みのまま保存だけが権限エラーになるため、ログイン画面に戻す
 */
export const useSessionWatcher = () => {
  const { authStatus, setAuthStatus, setSnackbar } = useContext(UiContext);

  useEffect(() => {
    if (authStatus !== 'AUTHORIZED') {
      return undefined;
    }

    const unsubscribe = onAuthStateChanged(FirebaseAuth, (user) => {
      if (!user) {
        setAuthStatus('UN_AUTHORIZED');
        setSnackbar(labels.message.sessionExpired);
      }
    });

    return unsubscribe;
  }, [authStatus]);
};
